import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export interface KpiStatusItem {
  label: string;
  value: string | number;
  sublabel?: string;
}

export interface KpiStatusGroup {
  label:  string;
  icon?:  string;           // clase PrimeIcon, ej: 'pi-user'
  accent?: string;          // color del ícono y borde izquierdo del grupo
  cumplimiento: string | number;
  stats: [KpiStatusItem, KpiStatusItem, KpiStatusItem];
}

export interface KpiStatusCardConfig {
  title?: string;
  subtitle?: string;
  groups: KpiStatusGroup[];
}

@Component({
  selector: 'app-kpi-status-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './kpi-status-card.component.html',
  styleUrl: './kpi-status-card.component.scss',
})
export class KpiStatusCardComponent {
  @Input() config!: KpiStatusCardConfig;
  @Input() loading = false;

  hasCumplimiento(value: string | number): boolean {
    const raw = String(value ?? '').replace('%', '').trim();
    const n = Number(raw);
    return !Number.isNaN(n) && n > 0;
  }

  pct(value: string | number): number {
    const raw = String(value ?? '').replace('%', '').trim();
    const n = Number(raw);
    if (Number.isNaN(n)) return 0;
    return Math.max(0, Math.min(999, n));
  }

  status(pct: number): 'danger' | 'warn' | 'success' {
    if (pct < 30) return 'danger';
    if (pct < 70) return 'warn';
    return 'success';
  }

  statusText(pct: number): string {
    const s = this.status(pct);
    if (s === 'danger') return 'Bajo';
    if (s === 'warn') return 'Medio';
    return 'Alto';
  }

  statusIcon(pct: number): string {
    const s = this.status(pct);
    if (s === 'danger') return 'pi pi-times-circle';
    if (s === 'warn') return 'pi pi-exclamation-triangle';
    return 'pi pi-check-circle';
  }
}

